import React, { memo } from 'react';
import { KContainer, KDims } from 'uikit';

import { data } from './data';

import TemplateHeader from '../TemplateHeader';
import TemplateLayout from '../TemplateLayout';

const Pricing = () => {
  const isMobile = KDims.isMobile();

  return (
    <>
      <TemplateHeader title="Pricing" />
      <TemplateLayout data={data} />
      {!isMobile && <KContainer.View height={215} />}
    </>
  );
};

export default memo(Pricing);
